import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/reload',
      name: 'Reload',
      component:  () => import('../views/Reload.vue')
    },
    {
      path: '/socialmedia',
      name: 'Socialmedia',
      component: () => import('../views/Socialmedia/Socialmedia.vue')
    },
    {
      path: '/shop',
      name: 'Shop',
      component: () => import('../views/Shop/Shop.vue')
    },
    {
      path: '/video',
      name: 'Video',
      component: () => import('../views/Video.vue')
    },
    {
      path: '/exchange',
      name: 'Exchange',
      component: () => import('../views/Exchange/Exchange.vue')
    },
    {
      path: '/together',
      name: 'Together',
      component: () => import('../views/Together/together.vue')
    },
    {
      path: '/mine',
      name: 'Mine',
      component: () => import('../views/Mine/mine.vue'),
      children:[{
        path: 'items',
        name: 'myItems',
        component: () => import('../views/Mine/components/myItems.vue'),
      }]
    },
    {
      path: '/message',
      name: 'Message',
      component: () => import('../views/Message/message.vue')
    },
    {
      path: '/notification',
      name: 'Notification',
      component: () => import('../views/Notification/notification.vue')
    },
  ]
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}